import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const DeprecationNotice = styled.div`
  background-color: ${color("bg-light")};
  border-bottom: 1px solid ${color("border")};
`;
